const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgIntBuk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 26.458333 26.458333",
    id: "svg62986",
    "inkscape:version": "1.2.1 (9c6d41e410, 2022-07-14)",
    "sodipodi:docname": "buk-logo.svg",
    "xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
    "xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:svg": "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("sodipodi:namedview", {
    id: "namedview62988",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    "inkscape:showpageshadow": 2,
    "inkscape:pageopacity": 0,
    "inkscape:pagecheckerboard": 0,
    "inkscape:deskcolor": "#d1d1d1",
    "inkscape:document-units": "mm",
    showgrid: "false",
    "inkscape:zoom": 1.8173401,
    "inkscape:cx": -8.2538212,
    "inkscape:cy": 66.855952,
    "inkscape:window-width": 1366,
    "inkscape:window-height": 650,
    "inkscape:window-x": 0,
    "inkscape:window-y": 32,
    "inkscape:window-maximized": 1,
    "inkscape:current-layer": "layer1"
  }), /*#__PURE__*/React.createElement("defs", {
    id: "defs62983"
  }), /*#__PURE__*/React.createElement("g", {
    "inkscape:label": "Layer 1",
    "inkscape:groupmode": "layer",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g62955",
    transform: "matrix(1.9230769,0,0,1.9230769,-1893.4357,-1194.3948)",
    style: {
      strokeWidth: 0.52
    }
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f3bbab96-1d10-45a9-9867-a4dc20f93973",
    width: 13.758333,
    height: 13.758333,
    rx: 1.3229166,
    id: "rect57686",
    x: 984.58655,
    y: 621.08527,
    style: {
      fill: "#2f48a7",
      fillOpacity: 1,
      strokeWidth: 0.137583
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo4-copy",
    fill: "#ffffff",
    fillRule: "nonzero",
    style: {
      stroke: "none",
      strokeWidth: 1.13542
    },
    transform: "matrix(0.12117363,0,0,0.12117363,984.73672,625.36498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g61060",
    transform: "translate(-1.1474976e-5)",
    style: {
      strokeWidth: 1.13542
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 11.6602,0.5888 h 5.289 v 27.035 c 0,3.094 0.794,5.495 2.38,7.199 1.587,1.704 3.771,2.557 6.553,2.557 2.899,0 5.172,-0.833 6.818,-2.499 1.645,-1.665 2.468,-4.084 2.468,-7.257 0,-3.017 -0.892,-5.398 -2.674,-7.141 -1.783,-1.743 -4.124,-2.616 -7.023,-2.616 -2.468,0 -4.604,0.705 -6.406,2.116 v -5.289 c 2.154,-1.176 4.486,-1.763 6.993,-1.763 4.153,0 7.591,1.342 10.315,4.026 2.723,2.683 4.084,6.239 4.084,10.667 0,4.663 -1.42,8.277 -4.26,10.842 -2.842,2.567 -6.416,3.85 -10.726,3.85 -4.114,0 -7.445,-1.332 -9.991,-3.996 -2.548,-2.664 -3.82,-6.231 -3.82,-10.696 z",
    id: "Fill-1",
    style: {
      strokeWidth: 1.13542
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 70.0191,41.728 h -10.168 c -4.349,0 -7.464,-0.646 -9.344,-1.939 -1.685,-1.136 -2.754,-2.498 -3.203,-4.085 -0.452,-1.586 -0.676,-3.673 -0.676,-6.259 V 13.518 h 5.172 v 15.868 c 0,0.705 0.019,1.303 0.058,1.793 0.039,0.49 0.177,1.116 0.411,1.88 0.236,0.765 0.568,1.392 1,1.881 0.431,0.49 1.058,0.921 1.88,1.293 0.823,0.373 1.823,0.558 2.997,0.558 h 6.701 V 13.518 h 5.172 z",
    id: "Fill-3",
    style: {
      strokeWidth: 1.13542
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 93.5855,13.518 h 5.7 l -7.111,12.283 c 4.819,1.293 7.229,5.193 7.229,11.696 v 4.231 h -5.172 v -4.29 c 0,-2.625 -0.774,-4.652 -2.321,-6.083 -1.549,-1.43 -3.753,-2.146 -6.612,-2.146 -0.901,0 -1.821,0.06 -2.762,0.177 v 12.342 h -5.172 V 0.589 h 5.172 v 24.155 c 1.646,-0.236 3.291,-0.236 4.937,0 z",
    id: "Fill-5",
    style: {
      strokeWidth: 1.13542
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntBuk);
export default __webpack_public_path__ + "static/media/Int_BUK.9ab2406bf74d4d9bf6d86093c729b692.svg";
export { ForwardRef as ReactComponent };